import {
  FETCH_ASSISTANTURL_REQUEST,
  FETCH_ASSISTANTURL_SUCCESS,
  FETCH_ASSISTANTURL_ERROR,
  HANDLE_ASSISTANT_AUTHENTICATION_FAILURE,
  ASSISTANT_NAVIGATION_REQUEST,
  ASSISTANT_NAVIGATION_SUCCESS,
  ASSISTANT_NAVIGATION_CLEAR
} from "./constants";

export const initialState = {
  isFetching: false,
  hasError: false,
  errorMessage:
    "We're sorry, we couldn't load the Micromedex Assistant right now. Please try again later.",
  navigation: {}
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_ASSISTANTURL_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false
      };
    case FETCH_ASSISTANTURL_SUCCESS:
      return {
        ...state,
        assistantUrl: action.payload.assistantUrl,
        isFetching: false
      };
    case FETCH_ASSISTANTURL_ERROR:
    case HANDLE_ASSISTANT_AUTHENTICATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        hasError: true
      };
    case ASSISTANT_NAVIGATION_REQUEST:
      return {
        ...state,
        navigation: { isFetching: true }
      };
    case ASSISTANT_NAVIGATION_SUCCESS: {
      const { basePath, type, sectionKey, title } = action.payload;
      let fullSlug;
      switch (type) {
        case "indepthAnswers":
          fullSlug = `${basePath}/details/${sectionKey}`;
          break;
        case "quickAnswers":
          fullSlug = `${basePath}#${sectionKey}`;
          break;
        default:
          fullSlug = `${basePath}${title}`;
      }

      return {
        ...state,
        navigation: { isFetching: false, fullSlug }
      };
    }
    case ASSISTANT_NAVIGATION_CLEAR:
      return {
        ...state,
        navigation: {}
      };
    default:
      return { ...state };
  }
};
